module.exports = __webpack_public_path__ + "img/create.a36fdc9d.png";